import MenuItem from '@/models/MenuItem';

const menuItems: MenuItem[] = [
  {
    label: 'Accueil',
    route: 'home',
    icon: 'mdi-home',
    isOpen: false,
    children: [],
    activeRoutes: ['home'],
  },
  {
    label: 'Sessions',
    route: 'session_list',
    icon: 'mdi-hiking',
    isOpen: false,
    children: [
      {
        label: 'Importées',
        route: 'session_imported',
        icon: 'mdi-playlist-check',
        isOpen: false,
        children: [],
        activeRoutes: ['session_imported'],
      },
      {
        label: 'En attente',
        route: 'session_pending',
        icon: 'mdi-playlist-play',
        isOpen: false,
        children: [],
        activeRoutes: ['session_pending'],
      },
      {
        label: 'Archivées',
        route: 'session_archived',
        icon: 'mdi-playlist-star',
        isOpen: false,
        children: [],
        activeRoutes: ['session_archived'],
      },
    ],
    activeRoutes: ['session'],
  },
  {
    label: 'Mode',
    route: '',
    icon: 'mdi-code-tags',
    isOpen: false,
    children: [],
    activeRoutes: ['mode'],
  },
  {
    label: 'Données',
    route: '',
    icon: 'mdi-database',
    isOpen: false,
    children: [
      {
        label: 'Recherche',
        route: 'search',
        icon: 'mdi-magnify',
        isOpen: false,
        children: [],
        activeRoutes: ['search'],
      },
      {
        label: 'Requêtes',
        route: '',
        icon: 'mdi-database-search',
        isOpen: false,
        children: [],
        activeRoutes: ['session'],
      },
      {
        label: 'Préparation',
        route: '',
        icon: 'mdi-package-variant',
        isOpen: false,
        children: [],
        activeRoutes: [],
      },
      {
        label: 'Récupération',
        route: '',
        icon: 'mdi-briefcase-download-outline',
        isOpen: false,
        children: [],
        activeRoutes: [],
      },
      {
        label: 'Fiches informatives',
        route: '',
        icon: 'mdi-information-variant',
        isOpen: false,
        children: [],
        activeRoutes: [],
      },
      {
        label: 'Import externe',
        route: '',
        icon: 'mdi-application-import',
        isOpen: false,
        children: [],
        activeRoutes: [],
      },
    ],
    activeRoutes: ['mode'],
  },
  {
    label: 'Valorisation',
    route: 'mode',
    icon: 'mode',
    isOpen: false,
    children: [
      {
        label: 'Interne',
        route: 'internal_valorisation',
        icon: 'mdi-bank-transfer-in',
        isOpen: false,
        children: [],
        activeRoutes: [],
      },
      {
        label: 'Externe',
        route: '',
        icon: 'mdi-bank-transfer-out',
        isOpen: false,
        children: [],
        activeRoutes: [],
      },

    ],
    activeRoutes: ['mode'],
  },
  {
    label: 'Administration',
    route: 'administration',
    icon: 'mdi-tune',
    isOpen: false,
    children: [
      {
        label: 'Utilisateurs',
        route: 'user_list',
        icon: 'mdi-account-edit',
        isOpen: false,
        children: [],
        activeRoutes: ['mode'],
      },
    ],
    activeRoutes: ['user_list', 'administration'],
    role: 'ROLE_SUPER_ADMIN',
  },
];

export function findAll(): MenuItem[] {
  return menuItems;
}
